import React from 'react';
import { dataHooks } from '../../constants';
import { st, classes } from './InlineLabelWrapper.st.css.js';
const InlineLabelWrapper = ({ children, suffix, charCount, labelPlacement, labelSize, }) => (React.createElement("div", { "data-hook": dataHooks.labelIndicators, className: st(classes.root, {
        inlineWithSuffix: Boolean(suffix || charCount !== undefined),
        labelPlacement,
        labelSize,
    }) }, children));
export default InlineLabelWrapper;
//# sourceMappingURL=InlineLabelWrapper.js.map